import styled from 'styled-components';
import { SearchInput } from '~/modules/header/SearchInput';

export interface SidebarSection {
  section: string;
  links: string[];
}

interface CategorySidebarProps {
  sidebarData: SidebarSection[];
  showSearch?: boolean;
  onItemClick?: (item: string) => void;
  searchTerm?: string;
  onSearch?: (e: React.FormEvent<HTMLFormElement>) => void;
}

export function CategorySidebar({
  sidebarData,
  showSearch = true,
  onItemClick,
  searchTerm,
  onSearch,
}: CategorySidebarProps) {
  return (
    <Sidebar>
      {showSearch && (
        <SearchBox as="div">
          <SearchInput defaultValue={searchTerm} onSubmit={onSearch} />
        </SearchBox>
      )}

      <NavigationBox>
        {sidebarData.map((section, index) => (
          <NavSection key={index}>
            <SectionHeader>{section.section}</SectionHeader>
            <LinkList>
              {section.links.map((link, linkIndex) => (
                <NavLink key={linkIndex} onClick={() => onItemClick?.(link)}>
                  {link}
                </NavLink>
              ))}
            </LinkList>
          </NavSection>
        ))}
      </NavigationBox>
    </Sidebar>
  );
}

const Sidebar = styled.aside`
  flex-shrink: 0;
  width: 280px;
`;

const SearchBox = styled.div`
  background: var(--white);
  border: 1px solid var(--grey-300);
  border-radius: 4px;
  margin-bottom: 21px;
  padding: 20px 16px;

  form {
    margin: 0;
  }
`;

const NavigationBox = styled.div`
  background: var(--white);
  border: 1px solid var(--grey-300);
  border-radius: 4px;
  padding: 20px 20px 20px 15px;
`;

const NavSection = styled.div`
  &:not(:last-child) {
    margin-bottom: 28px;
  }
`;

const SectionHeader = styled.h4`
  color: var(--grey-900);
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.9px;
  margin: 0 0 20px 0;
  text-transform: uppercase;
`;

const LinkList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const NavLink = styled.li`
  cursor: pointer;
  font-size: 14px;
  letter-spacing: -0.1px;
  padding-bottom: 13px;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: var(--wbs-red);
  }
`;
